import { Navigate } from 'react-router-dom'
import {
  ERT_CUSTOMER_CARE_SCOPE,
  ERT_INSPECT_MODE_SCOPE,
  ERT_QA_MODE_SCOPE,
  ERT_SCOPE,
  READ_ALARMS_SCOPE,
  READ_ALARM_RECORDINGS_SCOPE,
  READ_DEVICES_SCOPE,
  READ_ENGAGEMENTS_SCOPE
} from '../../constants'
import { AppRoute } from '../../auth/routeAuth'
import { ErtSearchPage } from './ErtSearchPage'
import { ErtPage } from './ErtPage/ErtPage'
import { AlarmSearch } from './ErtSearchPage/AlarmSearch'
import { EngagementSearch } from './ErtSearchPage/EngagementSearch'
import { ModeType } from './ErtPage/EngagementDetailsEnums'
import { ErtInspect } from './ErtPage/ErtInspect/ErtInspect'
import { RequireSid } from '../../components/RequireSid'
import { ErtQA } from './ErtPage/ErtQA/ErtQA'
import { ErtAlarmPage } from './ErtPage/ErtAlarmPage'
import { ErtCustomerCare } from './ErtPage/ErtCustomerCare/ErtCustomerCare'

/**
 * Note: Top-level components need to render a Page Component
 */
export const engagementReviewRoutes: AppRoute[] = [
  {
    index: true,
    element: <Navigate to="search" replace />
  },
  {
    path: 'search',
    element: <ErtSearchPage />,
    children: [
      {
        path: 'engagement',
        element: <EngagementSearch />,
        auth: { scopes: [ERT_SCOPE, READ_ENGAGEMENTS_SCOPE], mode: 'all' }
      },
      {
        path: 'alarm',
        element: <AlarmSearch />,
        auth: { scopes: [ERT_SCOPE, READ_ALARMS_SCOPE], mode: 'all' }
      }
    ]
  },
  {
    // Engagement and alarm detail views require a location sid in the path —
    // missing-sid links 404 instead of rendering a broken page.
    element: <RequireSid />,
    children: [
      {
        path: ':engagementId',
        children: [
          {
            index: true,
            element: <Navigate to={`mode/${ModeType.QA.toLowerCase()}`} replace={true} />
          },
          {
            path: `mode`,
            element: <ErtPage />,
            children: [
              {
                index: true,
                // this is needed to redirect visitors to /mode to the default mode (QA) instead of showing a blank page
                element: <Navigate to={ModeType.QA.toLowerCase()} replace={true} />
              },
              {
                path: ModeType.QA.toLowerCase(),
                handle: { mode: ModeType.QA },
                auth: { scopes: [ERT_SCOPE, READ_ENGAGEMENTS_SCOPE, READ_DEVICES_SCOPE, ERT_QA_MODE_SCOPE], mode: 'all' },
                element: <ErtQA />
              },
              {
                path: ModeType.Inspect.toLowerCase(),
                handle: { mode: ModeType.Inspect },
                auth: {
                  scopes: [ERT_SCOPE, READ_ENGAGEMENTS_SCOPE, READ_ALARM_RECORDINGS_SCOPE, READ_DEVICES_SCOPE, ERT_INSPECT_MODE_SCOPE],
                  mode: 'all'
                },
                element: <ErtInspect />
              },
              {
                path: ModeType.CustomerCare.toLowerCase(),
                handle: { mode: ModeType.CustomerCare },
                auth: {
                  scopes: [ERT_SCOPE, READ_ENGAGEMENTS_SCOPE, READ_DEVICES_SCOPE, ERT_CUSTOMER_CARE_SCOPE],
                  mode: 'all'
                },
                element: <ErtCustomerCare />
              }
            ]
          }
        ]
      },
      {
        path: 'alarm/:alarmId',
        element: <ErtAlarmPage />,
        auth: { scopes: [ERT_SCOPE, READ_ALARMS_SCOPE, READ_DEVICES_SCOPE], mode: 'all' }
      }
    ]
  }
]
